import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MentorService {

  constructor(
    private _http: HttpClient
  ){}

  public getStudents():Observable<any>{
    return this._http.get(environment.apiEndpoint+`/api/mentor/students`).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public getPractices():Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/mentor/practices').pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public removeStudent(id:number):Observable<any>{
    return this._http.delete(environment.apiEndpoint+`/api/mentor/student/${id}`).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public removeMentor(practiceId:number, mentorId:number):Observable<any>{
    return this._http.delete(environment.apiEndpoint+`/api/mentor/${practiceId}/${mentorId}`).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }
}
